import { render, staticRenderFns } from "./RelatedBusinessUnits.vue?vue&type=template&id=f16814d6&"
import script from "./RelatedBusinessUnits.vue?vue&type=script&lang=js&"
export * from "./RelatedBusinessUnits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports